import { object, string } from "yup";

const ZIP_CODE_REQUIRED = "A zip code is required";
const ZIP_CODE_FORMAT = "Please enter a valid zip code format, e.g. 90210";
const ZIP_CODE_LENGTH = "Zip code cannot be longer than 5 numbers";

export const zipCodeSchema = object({
  zipCode: string()
    .trim()
    .max(5, ZIP_CODE_LENGTH)
    .matches(/\d{5}/, {
      message: ZIP_CODE_FORMAT,
    })
    .required(ZIP_CODE_REQUIRED)
    .nullable(),
});
